const UserRole = {
  Admin: {
    id: "a652a97a-6f6c-4508-bfee-64b2298cede2",
    name: "Admin",
    lczKey: ""
  },
  User: {
    id: "93abf3bb-a34d-464e-ab2b-99bdfc44cf64",
    name: "User",
    lczKey: ""
  },
  PublicArticlesEditor: {
    id: "47f26316-00b2-4df5-84cf-b7219dd2f624",
    name: "PublicArticlesEditor",
    lczKey: ""
  },
  PagesEditor: {
    id: "7e464ac2-8a46-43fb-aa60-c4ea3352452f",
    name: "PagesEditor",
    lczKey: ""
  },
  NewsEditor: {
    id: "cedd7f91-07b8-48db-abc5-070213c8f399",
    name: "NewsEditor",
    lczKey: ""
  },
  SurveyEditor: {
    id: "7574c181-a706-4c7c-9689-b77791bc5dec",
    name: "SurveyEditor",
    lczKey: ""
  }
};
export {
  UserRole
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVXNlclJvbGUuanMiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zdGFudHMvVXNlclJvbGUuanMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IFVzZXJSb2xlID0ge1xuXHRBZG1pbjoge1xuXHRcdGlkOiBcImE2NTJhOTdhLTZmNmMtNDUwOC1iZmVlLTY0YjIyOThjZWRlMlwiLFxuXHRcdG5hbWU6IFwiQWRtaW5cIixcblx0XHRsY3pLZXk6IFwiXCIsXG5cdH0sXG5cdFVzZXI6IHtcblx0XHRpZDogXCI5M2FiZjNiYi1hMzRkLTQ2NGUtYWIyYi05OWJkZmM0NGNmNjRcIixcblx0XHRuYW1lOiBcIlVzZXJcIixcblx0XHRsY3pLZXk6IFwiXCIsXG5cdH0sXG5cdFB1YmxpY0FydGljbGVzRWRpdG9yOiB7XG5cdFx0aWQ6IFwiNDdmMjYzMTYtMDBiMi00ZGY1LTg0Y2YtYjcyMTlkZDJmNjI0XCIsXG5cdFx0bmFtZTogXCJQdWJsaWNBcnRpY2xlc0VkaXRvclwiLFxuXHRcdGxjektleTogXCJcIixcblx0fSxcblx0UGFnZXNFZGl0b3I6IHtcblx0XHRpZDogXCI3ZTQ2NGFjMi04YTQ2LTQzZmItYWE2MC1jNGVhMzM1MjQ1MmZcIixcblx0XHRuYW1lOiBcIlBhZ2VzRWRpdG9yXCIsXG5cdFx0bGN6S2V5OiBcIlwiLFxuXHR9LFxuXHROZXdzRWRpdG9yOiB7XG5cdFx0aWQ6IFwiY2VkZDdmOTEtMDdiOC00OGRiLWFiYzUtMDcwMjEzYzhmMzk5XCIsXG5cdFx0bmFtZTogXCJOZXdzRWRpdG9yXCIsXG5cdFx0bGN6S2V5OiBcIlwiLFxuXHR9LFxuXHRTdXJ2ZXlFZGl0b3I6IHtcblx0XHRpZDogXCI3NTc0YzE4MS1hNzA2LTRjN2MtOTY4OS1iNzc3OTFiYzVkZWNcIixcblx0XHRuYW1lOiBcIlN1cnZleUVkaXRvclwiLFxuXHRcdGxjektleTogXCJcIixcblx0fSxcbn07XG5cbmV4cG9ydCBjb25zdCBVc2VyUm9sZUFycmF5ID0gT2JqZWN0LnZhbHVlcyhVc2VyUm9sZSk7XG5cbmV4cG9ydCBjb25zdCBnZXRVc2VyUm9sZUJ5SWQgPSAoaWQpID0+IFVzZXJSb2xlQXJyYXkuZmluZCgoeCkgPT4geC5pZCA9PT0gaWQpO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFZLE1BQUMsV0FBVztBQUFBLEVBQ3ZCLE9BQU87QUFBQSxJQUNOLElBQUk7QUFBQSxJQUNKLE1BQU07QUFBQSxJQUNOLFFBQVE7QUFBQSxFQUNSO0FBQUEsRUFDRCxNQUFNO0FBQUEsSUFDTCxJQUFJO0FBQUEsSUFDSixNQUFNO0FBQUEsSUFDTixRQUFRO0FBQUEsRUFDUjtBQUFBLEVBQ0Qsc0JBQXNCO0FBQUEsSUFDckIsSUFBSTtBQUFBLElBQ0osTUFBTTtBQUFBLElBQ04sUUFBUTtBQUFBLEVBQ1I7QUFBQSxFQUNELGFBQWE7QUFBQSxJQUNaLElBQUk7QUFBQSxJQUNKLE1BQU07QUFBQSxJQUNOLFFBQVE7QUFBQSxFQUNSO0FBQUEsRUFDRCxZQUFZO0FBQUEsSUFDWCxJQUFJO0FBQUEsSUFDSixNQUFNO0FBQUEsSUFDTixRQUFRO0FBQUEsRUFDUjtBQUFBLEVBQ0QsY0FBYztBQUFBLElBQ2IsSUFBSTtBQUFBLElBQ0osTUFBTTtBQUFBLElBQ04sUUFBUTtBQUFBLEVBQ1I7QUFDRjsifQ==
